export class CustomError extends Error {
	code: string;

	constructor(message: string, code: string) {
		super(message);
		this.code = code;
		this.name = `CustomError - ${code}`;
		console.error(this);
	}
}
